var map = {
	"./1.jpg": 83016,
	"./10.jpg": 32604,
	"./11.jpg": 45692,
	"./12.jpg": 95197,
	"./13.jpg": 87088,
	"./14.jpg": 78680,
	"./15.jpg": 34830,
	"./16.jpg": 82295,
	"./17.jpg": 68222,
	"./18.jpg": 87774,
	"./19.jpg": 82689,
	"./2.jpg": 74810,
	"./20.jpg": 64073,
	"./3.jpg": 91660,
	"./4.jpg": 58747,
	"./5.jpg": 85961,
	"./6.jpg": 13839,
	"./7.jpg": 6246,
	"./8.jpg": 40404,
	"./9.jpg": 40329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99167;